import { render } from "./Routage.vue?vue&type=template&id=6b77adc6"
const script = {}

import exportComponent from "C:\\Users\\PIERRE\\Documents\\Projet\\SiteDucreOnline\\Front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__